import { StyledFlexContainer, StyledAppNumberInputWrapper } from './styles';
import AppNumberInput from 'components/FormElements/AppNumberInput';

type ShareConsideration = {
  shareholdingId: string;
  sharesAllocatedForSale: number;
  suggestedSharesAllocatedForSale: number;
  noOfShares: number;
};

type Props = {
  cell: ShareConsideration;
  setOverride: (
    shareholdingId: string,
    data: Partial<ShareConsideration>,
  ) => void;
  disableTable: boolean;
};

const ExitSharesSoldCell: React.FC<Props> = ({
  cell,
  setOverride,
  disableTable,
}) => {
  const isInputChanged =
    cell.sharesAllocatedForSale !== cell.suggestedSharesAllocatedForSale;
  const isInputTooHigh = cell.sharesAllocatedForSale > cell.noOfShares;

  return (
    <StyledFlexContainer>
      <StyledAppNumberInputWrapper isInputChanged={isInputChanged}>
        <AppNumberInput
          disabled={disableTable}
          defaultValue={0}
          min={0}
          fullWidth
          decimals={10}
          value={cell.sharesAllocatedForSale}
          onChange={(value) => {
            setOverride(cell.shareholdingId, {
              sharesAllocatedForSale: Number(value),
            });
          }}
          error={isInputTooHigh}
          helperText={isInputTooHigh ? 'Not enough shares' : ''}
        />
      </StyledAppNumberInputWrapper>
    </StyledFlexContainer>
  );
};

export default ExitSharesSoldCell;
